import React, { useEffect, useState } from 'react'
import { timer } from 'rxjs'
import { IPieChartData, LineGraph, PieChart, StatsList, TreeMap } from '@cicero/ui/charts'
import { generateLineGraphData, generatePieChartData, generateTreeMapData, stats } from '@cicero/ui/charts/__testing__'
import { IEditorWidget } from '../EditorService'

const treeData = generateTreeMapData(5)
const graphData = generateLineGraphData(50)

const PieWidget = () => {
  const [data, setData] = useState<IPieChartData[]>(generatePieChartData(50))
  useEffect(() => {
    const sub = timer(5000, 5000).subscribe(v => setData(generatePieChartData(v)))
    return () => sub.unsubscribe()
  }, [])
  return <PieChart data={data} />
}

export const treeMapChartWidget: IEditorWidget = {
  id: 'treemap',
  name: 'Tree Map',
  description: 'View chunks',
  image: require('./img/pie.png'),
  renderer: () => <TreeMap data={treeData} />,
}

export const statsTableWidget: IEditorWidget = {
  id: 'stats',
  name: 'Stats Table',
  description: 'Shows one or more stats based on aggregated data',
  image: require('./img/table.png'),
  renderer() {
    return <StatsList items={stats} tableThreshold={6} />
  },
}

export const graphChartWidget: IEditorWidget = {
  id: 'graphchart',
  name: 'Graph Chart',
  description: 'Break down data as a graph',
  image: require('./img/graph.png'),
  renderer: () => <LineGraph data={graphData} />,
}

export const pieChartWidget: IEditorWidget = {
  id: 'piechart',
  name: 'Pie Chart',
  description: 'Break down data as a pie',
  image: require('./img/pie.png'),
  renderer() { return <PieWidget /> },
}
